import { Component, EventEmitter, Output } from '@angular/core';

import { ApiError, MessageService } from '../../../../../core';
import { UsuarioEmailAdministrativoHttpService } from '../services';
import { UsuarioEmailAdministrativoSelect } from './usuario-email-administrativo-select';

@Component({
    selector: 'sgt-usuario-email-administrativo-select',
    templateUrl: './usuario-email-administrativo-select.component.html',
    styleUrls: ['./usuario-email-administrativo-select.component.less']
})
export class UsuarioEmailAdministrativoSelectComponent {
    entities: UsuarioEmailAdministrativoSelect[];

    @Output() toggleSelect = new EventEmitter<UsuarioEmailAdministrativoSelect>();

    constructor(private messageService: MessageService,
                private usuarioEmailAdministrativoHttpService: UsuarioEmailAdministrativoHttpService) { }

    /** Cria os e-mails administrativos do usuário para a seleção dos mesmos */
    create() {
        this.entities = [];
        this.usuarioEmailAdministrativoHttpService.searchUsuarioLogado()
            .subscribe(
                emailsAdministrativos => {
                    if (emailsAdministrativos) {
                        emailsAdministrativos.forEach(emailAdministrativo => {
                            const entity = new UsuarioEmailAdministrativoSelect(emailAdministrativo.email);
                            this.entities.push(entity);
                        });
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar os seus e-mails administrativos', error);
                }
            );
    }

    /** Ao alterar a seleção de um e-mail */
    toggle(entity: UsuarioEmailAdministrativoSelect) {
        entity.selected = !entity.selected;
        this.toggleSelect.emit(entity);
    }
}
